// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_user_files_s3_bucket": "mqc-prod",   //用于后端、上传的s3桶
    "aws_user_files_s3_bucket_region": "us-east-1",
    Auth: {
      // identityPoolId: "us-east-1:3eb05275-6ac6-4783-b65a-297249c852f1", 
      identityPoolId: "us-east-1:3eb05275-6ac6-4783-b65a-297249c852f1",
      region: "us-east-1", 
  
      oauth: {
      },
    },


    API: {
      endpoints: [
        {
          name: "MQC",
          endpoint:"https://55u3pt7och.execute-api.us-east-1.amazonaws.com/prod",
          region: "us-east-1", 
        },
        {
          name: "Feedback",
          endpoint:"https://gsh8w3wc88.execute-api.us-east-1.amazonaws.com/prod",
          region: "us-east-1", 
        },
        {
          name: "Modify1",
          endpoint:"https://vsnivt2yw7omil56h2xr5vhtyy0qxvrf.lambda-url.us-east-1.on.aws",
          service:"lambda",
          region: "us-east-1", 
        },
        {
          name: "Modify2",
          endpoint:"https://gbddar5solulrlxqsopetox2uq0uinsb.lambda-url.us-east-1.on.aws",
          service:"lambda",
          region: "us-east-1", 
        },
        
        
      ],
    }
};


export default awsmobile;
